'use client';

import * as React from 'react';
import Image from 'next/image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';

import { Typography } from '@components/typography';
import { Link } from '@components/link';
import { routes } from '@routes';
import { getListPagePartners } from '@utils/partners';

const pmsIntegrations = getListPagePartners();

const benefits = [
  'Bookings flow automatically. No manual entry.',
  'No delayed payments. You are merchant of record.',
  'Your guest data stays yours for marketing and loyalty.',
];

export const PmsIntegrationSection: React.FC = () => {
  const logos = [...pmsIntegrations, ...pmsIntegrations];

  return (
    <div className="bg-primary-main w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-12 sm:py-16">
        {/* Heading */}
        <Typography
          variant="title4"
          component="h2"
          className="text-center text-white !text-2xl sm:!text-3xl lg:!text-4xl"
        >
          Savvy integrates with your property management system
        </Typography>
        <Typography
          variant="body1"
          component="p"
          className="text-center text-white/80 mt-3 !text-base sm:!text-lg"
        >
          Seamless two-way sync with leading PMS platforms:
        </Typography>

        {/* Logo Marquee */}
        <div className="relative mt-8 -mx-4 sm:-mx-8 overflow-hidden">
          <div
            className="flex items-center gap-12 animate-partner-marquee"
            style={{ width: `${logos.length * 12}rem` }}
          >
            {logos.map((partner, idx) => (
              <div
                key={idx}
                className="flex flex-col items-center min-w-[8rem]"
              >
                <Image
                  src={partner.logoSvg}
                  alt={partner.title}
                  className="w-full h-14 object-contain brightness-0 invert opacity-80"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Benefit Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 mt-10 max-w-5xl mx-auto">
          {benefits.map((benefit) => (
            <div
              key={benefit}
              className="bg-white/10 border border-white/10 rounded-xl p-6 flex flex-col items-center gap-3 text-center"
            >
              <FontAwesomeIcon
                icon={faCircleCheck}
                className="text-secondary-main h-6 w-6"
              />
              <Typography
                variant="body1"
                component="p"
                className="text-white !text-sm sm:!text-base"
              >
                {benefit}
              </Typography>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <Typography
          variant="body1"
          component="p"
          className="text-center text-white mt-10 !text-base"
        >
          Don&rsquo;t see your PMS?{' '}
          <Link
            to={routes.contactSupport}
            className="text-white underline underline-offset-2 hover:text-white/80"
          >
            Contact us
          </Link>{' '}
          &ndash; we&rsquo;re adding new integrations regularly.
        </Typography>
      </div>
    </div>
  );
};
